import PaymentsScreen from './PaymentsScreen';

export default PaymentsScreen;
